// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"452":"747e80078296691f7396","896":"e46977e69aeeda1946b0"}[chunkId] + ".js";
};